import React, { Component } from "react";
import AddTitleBar from "../../../components/titleBar/add_titleBar";
import InsertConsignee from "../../../components/consigneeComponent/insertConsignee";
import { translate } from "react-i18next";
import Axios from 'axios';
import ReadAxios from "../../../components/axiosComponent/read";
import { isEmpty } from "lodash";

class AddConsignee extends Component {
  constructor(props) {
    super(props);
    this.state = {
      title: "title",
      editData: {},
      billingPartyId: "",
      billingPartyBranchId: '',
      billingPartyBranchArray: []
    };
  }

  componentDidMount() {
    if (this.props.location.state && this.props.location.state.title) {
      this.setState({
        title: this.props.location.state.title,
        editData: { ...this.props.location.state },
      });
    }
    ReadAxios({
      url: "users/consignee",
      readItems: {
        consigneeId:
          this.props.location.state && this.props.location.state.consigneeId,
      },
    })
      .then((dataArray) => {
        // console.log('...', dataArray.data.resultSet)
        isEmpty(dataArray)
          ? this.setState({ loadingData: false, rowData: [] })
          : this.setState({
              loadingData: false,
              rowData: dataArray.data.resultSet,
            });
      })
      .catch((err) => {
        console.log(err);
        this.setState({ loadingData: false, rowData: [] });
      });

    if(this.props.location.state && this.props.location.state.consigneeId){
    

      let token = localStorage.getItem('isloggedIn')
      let userId = localStorage.getItem('userId')
      let customerNo = localStorage.getItem('customerNumber')

      Axios.get(`${process.env.REACT_APP_MASTER_API}/mappings/consignee_billing_party_branch/?customerNumber=${customerNo}&userId=${userId}&consigneeId=${this.props.location.state && this.props.location.state.consigneeId}`, {
          headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json',
              'Authorization': token
          }
      }).then((response => {

        this.setState({
          billingPartyId: response.data.resultSet[0].billingPartyId,
          billingPartyBranchId: response.data.resultSet[0].billingPartyBranchId,
          consigneeBillingPartyBranchMapId: response.data.resultSet[0].consigneeBillingPartyBranchMapId
        });

        Axios.get(`${process.env.REACT_APP_MASTER_API}/billing_party_branch?customerNumber=${customerNo}&userId=${userId}&billingPartyId=${response.data.resultSet[0].billingPartyId}`, {
          headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json',
              'Authorization': token
          }
        }).then((response => {
          this.setState({ billingPartyBranchArray: response.data.resultSet });
        }))
          .catch(error => console.log(error))


      }))
        .catch(error => console.log(error))
    }
  
  }

  onFormSubmit = () => {
    this.props.history.push("/consignee");
    this.props.history.go();
  };

  render() {
    return (
      <React.Fragment>
        <AddTitleBar
          Title={this.props.t(this.state.title)}
          LinkName="/consignee"
        />
        <div className="m-2">
          <InsertConsignee
            editData={this.state.editData}
            billingPartyId={this.state.billingPartyId}
            billingPartyBranchId={this.state.billingPartyBranchId}
            consigneeBillingPartyBranchMapId={this.state.consigneeBillingPartyBranchMapId}
            billingPartyBranchArray={this.state.billingPartyBranchArray}
            onFormSubmit={this.onFormSubmit}
            usersList={this.state.rowData}
            action={this.state.title}
          />
        </div>
      </React.Fragment>
    );
  }
}
export default translate("create_consignee")(AddConsignee);
